<template>
  <div class="content">
    <div class="tagleft" style="width: 20%">
      <img src="../../static/cooperation_partner.png" style="height: 80px;"/>
      <img src="../../static/line.png" class="icon-line" />
      <div class="leftTitle">合作伙伴</div>
    </div>
    <div class="list">
      <div class="item" v-for="(v,i) of partnerData" :key="i">
        <div class="item-left"><span>{{v.classify}}</span></div>
        <div class="item-right">
          <img
            :src="item.iconOssUrl"
            alt=""
            class="img"
            v-for="(item,itemInd) of v.partnerList" :key="itemInd"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "partner",
  data(){
    return {
      partnerData:[]
    }
  },
  created() {
    this.getData()
  },
  methods:{
    getData(){
      this.$api.getPartnerApi().then(res=>{
        this.partnerData = res.data
      })
    }
  }
};
</script>

<style scoped lang="less">
.content {
  min-width: 93.75rem /* 1500/16 */;
  padding: 100px 6.5rem;
  width: 93.75rem;
  margin: 0 auto;
}
.tagleft {
  img {
    display: block;
  }
  .icon-line {
    width: 89px;
    margin-top: 36px;
    margin-bottom: 30px;
  }
  .leftTitle {
    font-size: 35px;
    font-weight: bold;
  }
}
.list {
  margin-top: 70px;
  width: 100%;
  .item {
    width: 100%;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    min-height: 90px;
    margin-top: 30px;
    .item-left {
      font-size: 16px;
      color: #fff;
      background-color: #1e439b;
      border-radius: 10px 0px 0px 10px;
      padding: 0 17px;
      max-width: 70px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      overflow: hidden;
    }
    .item-right {
      width: calc(100% - 70px);
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .tag {
        padding: 20px;
      }
      .img {
        width: 180px;
        height: 90px;
        box-shadow: 0px 2px 6px 0px rgba(19, 19, 19, 0.0902);
        //margin-left: 24px;
        margin: 10px 10px;
        &:last-child {
          //margin-top: 30px;
        }
      }
    }
  }
}
</style>
